import type { SVGProps } from "react";

export function GenieLampIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 64 64"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      data-slot="genie-lamp-icon"
    >
      <path
        d="M6 35c7 .2 11.5-1.4 15.5-5H44c0 11-7 17-17.5 17-9 0-15.5-4.2-17-10.2L6 35Z"
        fill="#d6a925"
        stroke="#4a3810"
        strokeLinejoin="round"
        strokeWidth="3"
      />
      <path d="M43 32c9-3 13 1 9.5 6-2 3-5.5 4-10 2.6M22 47h12M18 53h19" fill="none" stroke="#d6a925" strokeLinecap="round" strokeWidth="4" />
      <path d="M25 27c-2-5 5-6.5 3-12-1-3 1-6 5-7M34 26c5-4 1-7 4-10 2-2 4-2 6-1" fill="none" stroke="#d6a925" strokeLinecap="round" strokeWidth="4" />
    </svg>
  );
}
